import { useQuery } from '@tanstack/react-query'
import { ICowsList } from 'models/ICattlesData'
import CattlesApiService from 'services/cattlesApiServices'

const PAGE_SIZE = 100

const collectKeys = (
	cows: ICowsList[],
	tags: Set<string>,
	collars: Set<string>,
) => {
	cows.forEach(cow => {
		if (cow.tag_id != null && String(cow.tag_id) !== '') {
			tags.add(String(cow.tag_id))
		}
		if (cow.collar_num) {
			collars.add(String(cow.collar_num))
		}
	})
}

export const useUndigitizedCowKeys = (enabled: boolean) =>
	useQuery({
		queryKey: ['undigitized-cow-keys'],
		enabled,
		staleTime: 60_000,
		queryFn: async () => {
			const tags = new Set<string>()
			const collars = new Set<string>()
			const first = await CattlesApiService.getCowsList(
				undefined,
				undefined,
				1,
				PAGE_SIZE,
				undefined,
				undefined,
				false,
			)
			collectKeys(first.data.results, tags, collars)
			const pages = Math.ceil((first.data.count || 0) / PAGE_SIZE)
			if (pages > 1) {
				const rest = await Promise.all(
					Array.from({ length: pages - 1 }, (_, index) =>
						CattlesApiService.getCowsList(
							undefined,
							undefined,
							index + 2,
							PAGE_SIZE,
							undefined,
							undefined,
							false,
						),
					),
				)
				rest.forEach(response =>
					collectKeys(response.data.results, tags, collars),
				)
			}
			return { tags, collars }
		},
	})
